var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('app-side-bar-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/side-bar/SideBar.vue